import React from "react";
import {
  Flag16Regular,
  Location16Regular,
  Mail16Regular,
  Person16Regular,
  Phone16Regular,
} from "@fluentui/react-icons";
import InputReadOnlyField from "../form/field/read-only/Input";
import PhoneReadOnlyField from "../form/field/read-only/Phone";

const CandidateInfo = ({ candidate }) => {
  return (
    <>
      <InputReadOnlyField
        value={`
          ${candidate.Person.AddressPrimary.address},
          ${candidate.Person.AddressPrimary.postcode}, 
          ${candidate.Person.AddressPrimary.city}
        `}
        icon={<Location16Regular />}
      />
      <PhoneReadOnlyField value={candidate.Person.PhoneNumbers} icon={<Phone16Regular />} />
      <InputReadOnlyField value={`${candidate.Person.emailPrimary}`} icon={<Mail16Regular />} />
      <InputReadOnlyField value={`${candidate.Person.gender}`} icon={<Person16Regular />} />
      <InputReadOnlyField value={`${candidate.Person.AddressPrimary.country}`} icon={<Flag16Regular />} />
    </>
  );
};

export default CandidateInfo;
